import React, { useEffect, useRef, useState } from 'react';
import TextField from '../../../components/forms/TextField/TextField';
import { Controller } from 'react-hook-form';
import Select from '../../../components/forms/Select/Select';
import { Button } from '../../../components/forms/Buttons/Button';
import { toast } from 'react-toastify';
import {
  getUserDocumentTypes,
  postUserDocument,
  patchUserDocument,
} from '../../../services/Auth/authService';

const ContactInfo = ({ register, errors, user, countries, control }) => {
  const [docType, setDocType] = useState(null);
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [documentTypes, setDocumentTypes] = useState([]);

  useEffect(() => {
    getUserDocumentTypes().then((res) => {
      let results = res.results;
      if (user?.country?.code !== 'KAZ') {
        results = results.filter((type) => type.code !== 'ID');
      }
      setDocType(results[0].uuid);
      setDocumentTypes(results);
    });
  }, []);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file?.size > 1024 * 1024 * 5) {
      setFile(null);
      toast.error('File size must be less than 5MB');
      return;
    }

    if (file && file.size > 0) {
      setFile(file);
      const body = new FormData();
      body.append('document', file);
      body.append('user', user.uuid);
      body.append('doc_type', docType);
      if (user.documents?.[0]) {
        patchUserDocument(user.documents?.[0]?.uuid, body).then((res) => {
          window.location.reload();
        });
      } else {
        postUserDocument(body).then((res) => {
          window.location.reload();
        });
      }
    } else {
      setFile(null);
      toast.error('Please select a file');
    }
  };

  return (
    <div className="space-y-4">
      {/* Phone Number */}
      <TextField
        label="Phone Number"
        {...register('phone_number', {
          value: user.phone_number,
        })}
        placeholder="Phone Number"
      />

      <Controller
        name="country"
        control={control}
        defaultValue={user.country?.uuid}
        rules={{
          required: 'Country is required',
        }}
        render={({ field }) => (
          <Select
            label="Country"
            options={countries}
            value={field.value}
            onChange={(v) => field.onChange(v.value)}
            errorMsg={errors.country?.message}
            className="w-full"
            darkMode={true}
          />
        )}
      />

      {/* State */}
      <TextField
        label="State/Province"
        {...register('state', {
          value: user.state,
        })}
        placeholder="State/Province"
      />

      {/* City */}
      <TextField
        label="City"
        {...register('city', { value: user.city })}
        placeholder="City"
      />

      {/* Address */}
      <TextField
        label="Address"
        {...register('address', { value: user.address })}
        placeholder="Address"
      />

      <div className="flex flex-col justify-end gap-2">
        <div className="flex flex-row">
          {documentTypes.length > 1 &&
            documentTypes.map((type, index) => (
              <Button
                onClick={() => setDocType(type.uuid)}
                className={`${index !== 0 && 'rounded-l-none'} ${
                  index !== documentTypes.length - 1 && 'rounded-r-none'
                }`}
                type="button"
                text={type.name}
                color={docType === type.uuid ? 'primary' : 'secondary'}
              />
            ))}
        </div>
        <span className="text-sm ">
          Identification Document <span className="text-red-500">*</span>
        </span>
        <div
          className="flex flex-row gap-4 border border-gray-300 rounded-md p-4"
          onClick={() => fileInputRef.current.click()}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => {
            e.preventDefault();
            handleFileUpload({ target: { files: e.dataTransfer.files } });
          }}
        >
          <div className="flex flex-col gap-2 cursor-pointer">
            <p className="text-sm text-gray-500">Upload Zone</p>
            <p className="text-sm text-gray-500">
              Drag and drop your{' '}
              {documentTypes.map((type) => type.name).join(' or ')} here or
              click to upload
            </p>
          </div>
          <input
            className="hidden"
            id="file-upload"
            ref={fileInputRef}
            type="file"
            accept="image/*, application/pdf"
            onChange={handleFileUpload}
          />
        </div>
        {(user.documents?.[0] || file) && (
          <div
            className="flex flex-col gap-2 "
            onClick={() => {
              if (file) {
                const fileLink = URL.createObjectURL(file);
                window.open(fileLink, '_blank');
              } else {
                window.open(user.documents?.[0]?.document, '_blank');
              }
            }}
          >
            <p className="text-sm ">Uploaded File:</p>
            <p className="text-sm cursor-pointer text-blue-500 hover:underline w-fit  ">
              {file?.name || user.documents?.[0]?.document?.split('/').pop()}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactInfo;
